import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getActiveFeaturesRequest = {};
var _getActiveFeaturesResponse = {};
var _getAggregatedInfoRequest = {};
var _getAggregatedInfoResponse = {
    infoView: '_getInfoViewResponse',
    activeFeatures: '_getActiveFeaturesResponse',
};
var _getAllPropertiesRequest = {};
var _getInfoViewRequest = {};
var _getInfoViewResponse = {};
var _getOnBoardingStatusRequest = {};
var _getOnBoardingStatusResponse = {};
var _getPropertiesRequest = {};
var _getPropertiesResponse = {};
var _getServerPropertiesRequest = {};
var _getServerPropertiesResponse = {};
var _updateOnBoardingStatusRequest = {};
var _updateOnBoardingStatusResponse = {};
var _updatePropertiesRequest = {};
var _updatePropertiesResponse = {};
var _updateServerPropertiesRequest = {};
var _updateServerPropertiesResponse = {};
function resolveComWixBookingsBusinessApiV1BusinessUrl(opts) {
    var domainToMappings = {
        'bookings._base_domain_': [
            {
                srcPath: '/_api/business-server',
                destPath: '',
            },
            {
                srcPath: '/internal/business-server',
                destPath: '/internal',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/business-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/business-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/business-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/business-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/business-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/business-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/business-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** report business specific properties */
export function getInfo(payload) {
    var _a = serializer(_getInfoViewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInfoViewResponse, {}).fromJSON;
    function __getInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetInfo',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInfo.fromReq = fromReq;
    __getInfo.__isAmbassador = true;
    return __getInfo;
}
/** 6th button and BM onboarding state views */
export function getOnBoardingStatus(payload) {
    var _a = serializer(_getOnBoardingStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOnBoardingStatusResponse, {}).fromJSON;
    function __getOnBoardingStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetOnBoardingStatus',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/onboarding',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOnBoardingStatus.fromReq = fromReq;
    __getOnBoardingStatus.__isAmbassador = true;
    return __getOnBoardingStatus;
}
export function updateOnboardingStatus(payload) {
    var _a = serializer(_updateOnBoardingStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOnBoardingStatusResponse, {}).fromJSON;
    function __updateOnboardingStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'PATCH',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.UpdateOnboardingStatus',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/onboarding',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOnboardingStatus.fromReq = fromReq;
    __updateOnboardingStatus.__isAmbassador = true;
    return __updateOnboardingStatus;
}
/** Update properties for a given business. If the business already have properties then the given properties are added to the properties list */
export function updateProperties(payload) {
    var _a = serializer(_updatePropertiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePropertiesResponse, {}).fromJSON;
    function __updateProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'PATCH',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.UpdateProperties',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/properties',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProperties.fromReq = fromReq;
    __updateProperties.__isAmbassador = true;
    return __updateProperties;
}
export function updateServerProperties(payload) {
    var _a = serializer(_updateServerPropertiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateServerPropertiesResponse, {}).fromJSON;
    function __updateServerProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'POST',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.UpdateServerProperties',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/server_properties',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateServerProperties.fromReq = fromReq;
    __updateServerProperties.__isAmbassador = true;
    return __updateServerProperties;
}
export function getProperties(payload) {
    var _a = serializer(_getPropertiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPropertiesResponse, {}).fromJSON;
    function __getProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetProperties',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/properties',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProperties.fromReq = fromReq;
    __getProperties.__isAmbassador = true;
    return __getProperties;
}
export function getServerProperties(payload) {
    var _a = serializer(_getServerPropertiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServerPropertiesResponse, {}).fromJSON;
    function __getServerProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetServerProperties',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/server_properties',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getServerProperties.fromReq = fromReq;
    __getServerProperties.__isAmbassador = true;
    return __getServerProperties;
}
export function getAllProperties(payload) {
    var _a = serializer(_getAllPropertiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPropertiesResponse, {}).fromJSON;
    function __getAllProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetAllProperties',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/all_properties',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAllProperties.fromReq = fromReq;
    __getAllProperties.__isAmbassador = true;
    return __getAllProperties;
}
export function getActiveFeatures(payload) {
    var _a = serializer(_getActiveFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getActiveFeaturesResponse, {}).fromJSON;
    function __getActiveFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetActiveFeatures',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/active_features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getActiveFeatures.fromReq = fromReq;
    __getActiveFeatures.__isAmbassador = true;
    return __getActiveFeatures;
}
export function getAggregatedInfo(payload) {
    var _a = serializer(_getAggregatedInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAggregatedInfoResponse, {
        _getActiveFeaturesResponse: _getActiveFeaturesResponse,
        _getInfoViewResponse: _getInfoViewResponse,
    }).fromJSON;
    function __getAggregatedInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.business_info',
            method: 'GET',
            methodFqn: 'com.wix.bookings.business.api.v1.Business.GetAggregatedInfo',
            url: resolveComWixBookingsBusinessApiV1BusinessUrl({
                protoPath: '/v1/business/aggregated',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAggregatedInfo.fromReq = fromReq;
    __getAggregatedInfo.__isAmbassador = true;
    return __getAggregatedInfo;
}
//# sourceMappingURL=http.impl.js.map